/*
 * Sabroso scroll-reveal
 * -----------------------------------------------------------------------------
 * Elements with `.sb-reveal` fade + rise into view. They are FULLY VISIBLE by
 * default (see the base .sb-reveal rule in each section's stylesheet); this
 * script only "arms" (hides) them once it is confirmed running, then reveals
 * them on scroll via IntersectionObserver with a staggered delay per sibling.
 *
 * Degrades gracefully: if JS or IntersectionObserver is unavailable, nothing is
 * armed and everything stays visible. Respects prefers-reduced-motion. Safe to
 * load more than once (guarded by window.__sabrosoRevealInit).
 */
(function () {
  if (window.__sabrosoRevealInit) return;
  window.__sabrosoRevealInit = true;

  function init() {
    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // If motion is not wanted or the observer is missing, leave everything
    // in its visible base state and bail.
    if (reduce || !('IntersectionObserver' in window)) return;

    var els = Array.prototype.slice.call(
      document.querySelectorAll('.sb-reveal')
    );
    if (!els.length) return;

    function reveal(el) {
      var parent = el.parentElement;
      var sibs = parent
        ? Array.prototype.slice.call(
            parent.querySelectorAll(':scope > .sb-reveal')
          )
        : [el];
      var idx = Math.max(0, sibs.indexOf(el));
      el.style.transitionDelay = idx * 90 + 'ms';
      // Removing the armed class transitions back to the visible base state.
      el.classList.remove('sb-armed');
    }

    // Arm (hide) only now that we know we can animate them back in.
    els.forEach(function (el) {
      el.classList.add('sb-armed');
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            reveal(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });

    // Reveal anything already above the fold on the next frame.
    requestAnimationFrame(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.94) {
          reveal(el);
          io.unobserve(el);
        }
      });
    });

    // Safety net: never leave content hidden.
    setTimeout(function () {
      els.forEach(function (el) {
        if (el.classList.contains('sb-armed')) reveal(el);
      });
    }, 2600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
